import { makeAutoObservable } from 'mobx'
import PPSection from './Section'

export default class PPPresentation {
    id = ''

    locale = ''

    clientName = ''

    benchmarkPeriod = { periodType: '', duration: 0 }

    surveyId = []

    section = []

    benchmarks = []

    constructor(props) {
        this.id = props.id ?? ''
        this.locale = props.locale ?? ''
        this.clientName = props.clientName ?? ''

        if (Array.isArray(props.section)) {
            this.section = props.section.map((s) => new PPSection(s))
        }

        if (props.benchmarkPeriod) {
            this.benchmarkPeriod = props.benchmarkPeriod
        }

        makeAutoObservable(this)
    }

    addSection = (section, activeSection, position) => {
        if (position === 'above') {
            this.section.splice(activeSection, 0, new PPSection(section))
        } else {
            this.section.splice(activeSection + 1, 0, new PPSection(section))
        }
    }

    removeSection = (index) => {
        this.section.splice(index, 1)
    }

    addSurvey = (id) => {
        this.surveyId = new Set([...this.surveyId, id])
    }

    toggleBenchmark = (benchmark) => {
        if (this.benchmarks.includes(benchmark)) {
            this.benchmarks = this.benchmarks.filter((b) => b !== benchmark)
        } else {
            this.benchmarks.push(benchmark)
        }
    }

    toJSON = () => {
        const surveyIds = new Set()
        this.section.forEach(({ slide }) => {
            slide.forEach(({ question }) => {
                Array.from(question.values()).forEach(({ surveyId }) => {
                    surveyIds.add(surveyId.toUpperCase())
                })
            })
        })
        return {
            id: this.id,
            locale: this.locale,
            clientName: this.clientName,
            benchmarkPeriod: this.benchmarkPeriod,
            surveyId: Array.from(surveyIds),
            section: this.section.slice(),
        }
    }
}
